<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     费用中心-近12个消费趋势图
  +---------------------------------------------------------------------------------------
-->

<template>
  <div :id="chartId" :style="{ width: width, height: height }" />
</template>

<script>
import { getExpenseMonthTrendApi } from '@/api/expense/expenseOverviewApi'
import { debounce } from '@/utils/common'
export default {
  name: 'ExpenseTrendChart',
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '500px'
    },
    chartId: {
      type: String,
      default: function() {
        return 'chart-trend-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '')
      }
    }
  },
  data() {
    return {
      loading: false,
      chart: null,
      options: {
        title: {
          text: '近12个月消费统计'
        },
        legend: {
          right: 10
        },
        xAxis: {
          data: [],
          boundaryGap: true
        },
        yAxis: {
          type: 'value'
        },
        grid: {
          left: 10,
          right: 10,
          bottom: 10,
          // top: 10,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '消费',
            type: 'bar',
            barWidth: '38.2%',
            data: []
          },
          {
            name: '收入',
            type: 'bar',
            barWidth: '38.2%',
            data: []
          }
        ]
      }
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.initChart()
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize()
      }
    }, 100)
    window.addEventListener('resize', this.__resizeHandler)
  },
  beforeDestroy() {
    if (!this.chart) return
    window.removeEventListener('resize', this.__resizeHandler)
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById(this.chartId), 'teenager')
      this.chart.setOption(this.options)
    },
    fetchData() {
      this.loading = true
      getExpenseMonthTrendApi().then(res => {
        this.loading = false
        if (!res.errno) {
          this.options.xAxis.data = res.data.map(item => item.month)
          this.options.series[0].data = res.data.map(item => item.expense)
          this.options.series[1].data = res.data.map(item => item.earn)
          if (this.chart) {
            this.chart.setOption(this.options)
          }
        }
      })
    }
  }
}
</script>
